<div class="mb-1 border-solid border-b border-gray-300 bg-gray-100">
  <span class="text-gray-900 p-3 block text-md font-normal">{{poi.name}}</span>
</div>

<div class="p-3" [ngSwitch]="selectedIndex">
  <div *ngSwitchCase="0" class="details-list">
    <div title="Nom" class="head">Nom</div>
    <div>{{poi.name}}</div>
    <div title="Catégorie" class="head">Catégorie</div>
    <div>{{poi.category}}</div>
    <div title="Domaine" class="head">Domaine</div>
    <div>{{poi.domain_name}}</div>
    <div title="BU" class="head">BU</div>
    <div>{{poi.business_unit_name}}</div>
  </div>
  <div *ngSwitchCase="1">

    <form (submit)="onFormSubmit($event)">
      <dx-form id="form"
               labelLocation="left"
               [formData]="poi"
               [readOnly]="false"
               [showColonAfterLabel]="true"
               [showValidationSummary]="true"
               (onFieldDataChanged)="addFieldChange($event)">
        <dxi-item dataField="name" [editorOptions]="{stylingMode: 'outlined', height: '32px'}">
          <dxo-label text="Nom"></dxo-label>
          <dxi-validation-rule type="required" message="Le nom est obligatoire"></dxi-validation-rule>
          <dxi-validation-rule type="stringLength" [min]="3" [max]="100"></dxi-validation-rule>
        </dxi-item>
        <dxi-item dataField="color" editorType="dxColorBox"
                  [editorOptions]="{stylingMode: 'outlined', height: '32px'}">
          <dxo-label text="Couleur"></dxo-label>
          <dxi-validation-rule type="required" message="La couleur est obligatoire"></dxi-validation-rule>
        </dxi-item>
        <dxi-item dataField="domain_id">
          <dxo-label text="Domaine"></dxo-label>
          <div *dxTemplate>
            <app-user-domains-chooser (valueChange)="domainChange($event)"
                                      [id]="poi.domain_id" height="32px"></app-user-domains-chooser>
          </div>
        </dxi-item>
        <dxi-item dataField="category_id" editorType="dxSelectBox"
                  [editorOptions]="{dataSource: catDsLookup,
                     displayExpr: 'name',
                     disabled: editSelectCategoryDisabled,
                      valueExpr:'id',
                      stylingMode: 'outlined',
                      height: '32px'}">
          <dxo-label text="Catégorie"></dxo-label>
        </dxi-item>

        <dxi-item
          itemType="button"
          horizontalAlignment="right"
          [buttonOptions]="buttonOptions">
        </dxi-item>
      </dx-form>


    </form>
  </div>

  <div *ngSwitchCase="2">
  </div>
</div>

<div class="border-t border-gray-300 border-solid">
  <dx-tabs
    [dataSource]="tabs"
    [(selectedIndex)]="selectedIndex"
    [width]="450"
    (onItemClick)="selectTab($event)"
    [scrollByContent]="true"
    [showNavButtons]="true"
  ></dx-tabs>
</div>
